import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Local Types
import { OwnProps, ConnectedProps, Props } from './types';

// Local Selectors
import { makeSelectMyTimesheetEntryAlreadyExists } from './selectors';

/**
 * A component that checks if a timesheet entry already exists for a give date and time.
 * And passes that information down to the children.
 */
export class MyTimesheetEntryAlreadyExists extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { exists, children } = this.props;

        if (typeof children === 'function') {
            // @ts-ignore
            return children(exists);
        }
        // @ts-ignore
        return React.cloneElement(children, { exists });
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    exists: makeSelectMyTimesheetEntryAlreadyExists()
});

export default connect(mapStateToProps)(MyTimesheetEntryAlreadyExists);
